import { BASE_COLORS, media } from "config/theme/constants";
import { Divider, Typography } from "antd";
import styled from "styled-components";
import { MenuItem as MenuItemBase } from "components/common/Menu";
import { HeaderActionWrapper } from "components/header/styles";
import { DownOutlined } from "@ant-design/icons";

export const ProfileDropdownHeader = styled(HeaderActionWrapper)`
  cursor: pointer;

  .profile-icon,
  .profile-icon:hover {
    background: ${BASE_COLORS.alto} !important;
    color: ${BASE_COLORS.mineShaft} !important;
    border-color: ${BASE_COLORS.altolight};
    height: 35px;
    width: 35px;
  }

  @media only screen and ${media.md} {
    border-radius: 50px;
    padding: 0.3125rem 0.2rem;
  }
`;

export const DownArrow = styled(DownOutlined)`
  color: var(--text-secondary-color);

  @media only screen and ${media.md} {
    color: var(--text-main-color);
  }
`;

export const MenuItem = styled(MenuItemBase)`
  height: 50px;
`;

export const ItemsDivider = styled(Divider).withConfig({
  shouldForwardProp: (prop) => !["eventKey", "warnKey"].includes(prop),
})`
  margin: 0;
`;

export const AccountSettingsWrapper = styled.div`
  .form-container {
    width: 450px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    overflow-y: auto !important;
    height: 70vh;
  }
  .account-setting-form{
    input{
      border: none;
      font-size: 14px;
      padding: 0;
    }
  }
  .ant-descriptions-item-label, .ant-descriptions-item-content{
    font-family: "Poppins";
    font-size: 13px;
    padding: 10px !important;
    p{
      margin-top: 0;
      font-size: 13px;
      color: #000000;
      font-family: "Poppins";
    }
  }
`;

export const LabelDisplay = styled(Typography)`
  color: #000000;
  font-family: "Poppins";
  font-size: 13px;
`;
